export default __webpack_public_path__ + "static/media/2.124e7bae.svg";